/* eslint-disable import/no-unresolved */
import { useAppSelector } from "../../../../../utils/hooks/useAppSelector";
import CustomLabel from "../../../../../shared/CustomLabel";
import CustomReviewField from "../../../../../shared/CustomReviewField";

function GeneralDetails() {
  const generalDetailsData = useAppSelector((state: any) => state.generalDetails);
  const mefSchema = useAppSelector((state): any => state.masterdata_reducer?.mefJourneySchema);
  const generalDetailsMefFields = mefSchema?.genericDetails || {};
  return (
    <div>
      <div className="grid grid-flow-row-dense lg:grid-cols-3 grid-cols-2 gap-y-8 md:gap-x-28 gap-x-3 mt-6 max-sm:ml-4 ">
        {(generalDetailsData?.applicationNumber ||
          generalDetailsMefFields?.applicationNo?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{generalDetailsMefFields?.applicationNo?.label}</CustomLabel>
            <CustomReviewField>{generalDetailsData?.applicationNumber || "-"}</CustomReviewField>
          </div>
        )}

        {(generalDetailsData?.serviceBranchCode ||
          generalDetailsMefFields?.bankBranchCode?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{generalDetailsMefFields?.bankBranchCode?.label}</CustomLabel>
            <CustomReviewField>{generalDetailsData?.serviceBranchCode || "-"}</CustomReviewField>
          </div>
        )}

        {(generalDetailsData?.serviceBranchName ||
          generalDetailsMefFields?.bankBranchName?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{generalDetailsMefFields?.bankBranchName?.label}</CustomLabel>
            <CustomReviewField>{generalDetailsData?.serviceBranchName || "-"}</CustomReviewField>
          </div>
        )}

        {(generalDetailsData?.bankDistributorName ||
          generalDetailsMefFields?.bankDistributorName?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{generalDetailsMefFields?.bankDistributorName?.label}</CustomLabel>
            <CustomReviewField>{generalDetailsData?.bankDistributorName || "-"}</CustomReviewField>
          </div>
        )}

        {(generalDetailsData?.masterPolicyNumber ||
          generalDetailsMefFields?.masterPolicyNumber?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{generalDetailsMefFields?.masterPolicyNumber?.label}</CustomLabel>
            <CustomReviewField>{generalDetailsData?.masterPolicyNumber || "-"}</CustomReviewField>
          </div>
        )}

        {generalDetailsMefFields?.masterPolicyHolderName?.visible && (
          <div className="col-span-1">
            <CustomLabel>{generalDetailsMefFields?.masterPolicyHolderName?.label}</CustomLabel>
            <CustomReviewField>
              {generalDetailsData?.masterPolicyHolderName || "-"}
            </CustomReviewField>
          </div>
        )}

        {(generalDetailsData?.ageasFederalEmployeeCode ||
          generalDetailsMefFields?.ageasFederalEmployeeCode?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{generalDetailsMefFields?.ageasFederalEmployeeCode?.label}</CustomLabel>
            <CustomReviewField>
              {generalDetailsData?.ageasFederalEmployeeCode || "-"}
            </CustomReviewField>
          </div>
        )}

        {(generalDetailsMefFields?.staffFlag?.visible ||
          generalDetailsData?.isStaff !== undefined) && (
          <div className="col-span-1">
            <CustomLabel>{generalDetailsMefFields?.staffFlag?.label}</CustomLabel>
            <CustomReviewField>{generalDetailsData?.isStaff ? "Yes" : "No"}</CustomReviewField>
          </div>
        )}

        {generalDetailsData?.isStaff && (
          <>
            {(generalDetailsData?.staffCompany ||
              generalDetailsMefFields?.staffCompany?.visible) && (
              <div className="col-span-1">
                <CustomLabel>{generalDetailsMefFields?.staffCompany?.label}</CustomLabel>
                <CustomReviewField>{generalDetailsData?.staffCompany || "-"}</CustomReviewField>
              </div>
            )}
            {(generalDetailsData?.employeeCode ||
              generalDetailsMefFields?.employeeCode?.visible) && (
              <div className="col-span-1">
                <CustomLabel>{generalDetailsMefFields?.employeeCode?.label}</CustomLabel>
                <CustomReviewField>{generalDetailsData?.staffEmpCode || "-"}</CustomReviewField>
              </div>
            )}
            {(generalDetailsData?.staffST2Code || generalDetailsMefFields?.st2Code?.visible) && (
              <div className="col-span-1">
                <CustomLabel>{generalDetailsMefFields?.st2Code?.label}</CustomLabel>
                <CustomReviewField>{generalDetailsData?.staffST2Code || "-"}</CustomReviewField>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
export default GeneralDetails;
